import { gql } from '@apollo/client';

export const CHAPTERS_DTO = gql`
  fragment ChaptersDto on Chapter {
    chapterId
    chapterIndex
    name
    publishedAt
    willPublishAt
    freedAt
    willFreeAt
    price
    storyId
    userPurchasedChapter {
      usedAmount
    }
    story {
      bundleId
      playType
      languageCode
      genreKey {
        type
      }
    }
    remainingTimeToFree
    freeDependencyChapterIndex
    freeDependencyPeriod
    hasNewBadge
    hasGraphIcon
    hasBGM
    isTimeLeapFree
    endings {
      endingId
    }
  }
`;

export const PLAY_CHAPTERS_FRAGMENT = gql`
  fragment PlayChapterDto on UserPlayedChapter {
    chapterId
    playingStoryId
    selectedChoices {
      choice {
        name
      }
      selectedChoice
    }
    chapter {
      chapterIndex
      chapterScript
      hasBGM
    }
    currentProps
    currentItems
    ending {
      name
      endingId
      isFinal
      imageFile {
        link
      }
      createdAt
    }
    coinUsed
  }
`;

export const CHAPTER_PURCHASES_DTO = gql`
  fragment ChapterPurchasesDto on Story {
    storyId
    name
    purchasable
    purchased
    lastPreviewChapterIndex
    originalPrice
    price
    discountRate
    chapterPurchases {
      cpId
      chapterId
      usedAt
      refundedAt
      coinUsed
    }
    hasAdultChapter
    coinProduct {
      inappProductId
      inappCoinId
      productName
      amount
      originalPrice
      price
    }
  }
`;

export const NEXT_CHAPTER_DTO = gql`
  fragment NextChapterDto on Chapter {
    ...ChaptersDto
    story {
      name
      introImageFile {
        link
      }
      mainImageFile {
        link
      }
      originalPrice
      discountRate
      storygameCoverImageFile {
        link
      }
      ...ChapterPurchasesDto
    }
  }
  ${CHAPTERS_DTO}
  ${CHAPTER_PURCHASES_DTO}
`;

export const CHARACTER_DTO = gql`
  fragment CharacterDto on Chr {
    createdAt
    updatedAt
    chrId
    name
    storyId
    imageFile {
      link
    }
    portraitFile {
      link
    }
    imageFileId
    syncToken
    main
    color
    defaultFirstName
    defaultLastName
  }
`; // story는 제외

export const CURRENT_PLAYING_CHAPTER = gql`
  fragment CurrentPlayingChapter on UserPlayedChapter {
    chapterId
    chapter {
      chapterIndex
    }
    currentItems
    currentProps
    coinUsed
    selectedChoices {
      choice {
        name
      }
      choiceId
      selectedChoice
      leftUserInputText
      rightUserInputText
    }
    initProps
    profileImageFile {
      fileId
      link
    }
    profileImageFileId
    playingCharacters {
      playingCharacterId
      playingChapterId
      characterId
      firstName
      lastName
      profileImageFile {
        link
      }
      profileImageFileId
      character {
        ...CharacterDto
      }
      portraitImageFile {
        fileId
        link
      }
    }
    playerClassId
    playerClass {
      name
    }
    upcId
    playingRemoteScripts {
      remoteScriptId
      statements
    }
    portraitImageFile {
      fileId
      link
    }
    withAICustomCharacter
  }
  ${CHARACTER_DTO}
`;

export const CHOICE_DTO = gql`
  fragment ChoiceDto on Choice {
    choiceId
    chapterId
    storyId
    name
    displayName
    showStatistics
    numChoice
    choice1Content
    choice2Content
    choice3Content
    choice4Content
    choice5Content
    choice1DisplayName
    choice2DisplayName
    choice3DisplayName
    choice4DisplayName
    choice5DisplayName
    syncToken
    choice1Rate
    choice2Rate
    choice3Rate
    choice4Rate
    choice5Rate
    choice1ImageUrl
    choice2ImageUrl
    choice3ImageUrl
    choice4ImageUrl
    choice5ImageUrl
  }
`;

export const CHOICE_FROM_PLAYER_CLASSES = gql`
  fragment ChoiceFromPlayerClasses on ChoiceFromPlayerClass {
    choiceFromPlayerClassId
    choiceId
    choice {
      ...ChoiceDto
    }
    playerClass {
      playerClassId
      storyId
      name
    }
    playerClassId
    selectedChoice
    totalCount
    adminAddCount
    choiceRate
    realChoiceRate
  }
  ${CHOICE_DTO}
`;

export const CHOICE_RESULT = gql`
  fragment ChoiceResult on Choice {
    ...ChoiceDto
    choiceFromPlayerClasses {
      ...ChoiceFromPlayerClasses
    }
  }
  ${CHOICE_DTO}
  ${CHOICE_FROM_PLAYER_CLASSES}
`;

export const POPUP_PROFILE_IMAGE_DTO = gql`
  fragment PopupProfileImageDto on OnboardingPopupProfileImage {
    popupId
    profileImageFile {
      link
    }
    profileImageFileId
    description
    status
  }
`;

export const CHAT_BANNER_DTO = gql`
  fragment ChatBannerDto on ChapterOption {
    bannerImageConnectUrl
    status
    chapterOptionId
    bannerImageFileId
    bannerImageConnectUrl
    bannerImageFile {
      link
    }
  }
`;
